module.exports = __webpack_public_path__ + "static/media/red-flag-v2.920cfbcd.svg";